module.exports = __webpack_public_path__ + "img/excluded_area_yellow.043fb76a.svg";